import { render, staticRenderFns } from "./to-top.vue?vue&type=template&id=a417fc46&scoped=true&"
import script from "./to-top.vue?vue&type=script&lang=js&"
export * from "./to-top.vue?vue&type=script&lang=js&"
import style0 from "./to-top.vue?vue&type=style&index=0&id=a417fc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a417fc46",
  null
  
)

export default component.exports